import * as yup from "yup";
export const outreahLeaderAddSchema = yup.object().shape({
  name: yup.string().required("Required *"),
  email: yup
    .string()
    .email()
    .required("Required *"),
  username: yup.string().required("Required *"),
  password: yup
    .string()
    .required("Required *")
    .min(6, "Too short (minimum is 6 characters)"),
  counties: yup.array().nullable(),
  location: yup.string().required("Required *"),
});
export const outreahLeaderEditSchema = yup.object().shape({
  name: yup.string().required("Required *"),
  email: yup
    .string()
    .email()
    .required("Required *"),
  username: yup.string().required("Required *"),
  // password: yup
  //   .string()
  //   .required('Required *')
  //   .min(6, 'too short (minimum is 6 characters)'),
  counties: yup.array().nullable(),
  location: yup.string().required("Required *"),
});

export const PasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required("Required *")
    .min(6, "Too short (minimum is 6 characters)"),
  confirmPassword: yup
    .string()
    .required("Required *")
    .oneOf([yup.ref("password"), null], "Passwords must match"), // Add this validation
});

export const outreachLeaderInitialValues = {
  name: "",
  email: "",
  username: "",
  password: "",
  counties: [],
  location: "",
  status: "active",
};
export const LEADCARE_MANAGERS_COLUMNS = [
  { columnKey: "first_name", label: "Name", isSortable: true },
  { columnKey: "email", label: "Email", isSortable: true },
  { columnKey: "counties_names", label: "County", isSortable: true },
  { columnKey: "health_plans_names", label: "Health Plan", isSortable: true },
  {
    columnKey: "capacity",
    label: "Capacity Limit",
    isSortable: false,
  },
  {
    columnKey: "created_at",
    label: "Date Created",
    isSortable: true,
  },
];
